
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// A first-of-its-kind digital platform designed to solve daily challenges faced by Society Managing Committee. 

const images = [
  "/assets/img/HT_Scty_Prob1.png",
  "/assets/img/HT_Scty_Prob2.png",
  //  "/assets/img/HT_Scty_Prob3.png",
  "/assets/img/HT_Scty_Prob4.png",
  // "/assets/img/HT_Scty_Problem.png",
];

/// Start Maintenance Computation

const mc_images = [
  "/assets/img/Prod_Carousel/maint_comp1.png",
  "/assets/img/Prod_Carousel/maint_comp2.png",
];

function ImageCarouselMaintCompt() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % mc_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {mc_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Maintenance Computation

/// Start Commmunication with Members

const comm_mem_images = [
  "/assets/img/Prod_Carousel/comm_mobile1.png",
  "/assets/img/Prod_Carousel/comm_mobile2.png",
];

function ImageCarouselCommMembers() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % comm_mem_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {comm_mem_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Commmunication with Members

/// Start Commmunication with Members

const tant_park_images = [
  "/assets/img/Prod_Carousel/tenant_parking1.png",
  "/assets/img/Prod_Carousel/tenant_parking2.png",
];

function ImageCarouselTenantPark() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % tant_park_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {tant_park_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Commmunication with Members

/// Start Finance

const finance_images = [
  "/assets/img/Prod_Carousel/finance1.png",
  "/assets/img/Prod_Carousel/finance2.png",
];

function ImageCarouselFinance() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % finance_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {finance_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Finance

/// Start Finance

const mob_app_images = [
  "/assets/img/Prod_Carousel/mob_app_feat1.png",
  "/assets/img/Prod_Carousel/mob_app_feat2.png",
  "/assets/img/Prod_Carousel/mob_app_feat3.png",
];

function ImageCarouselMobApp() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % mob_app_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {mob_app_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// End Finance

const solution_images = [
  "/assets/img/HT_Solution1.png",
  "/assets/img/HT_Solution3.png",
  "/assets/img/HT_Solution4.png",
];

function ImageCarouselFade() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

function ImageCarouselSolution() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % solution_images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {solution_images.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

const feature_images1 = [
  "/assets/img/HT_Feature1.png",
  "/assets/img/HT_Feature2.png",
  "/assets/img/HT_Feature3.png",
];

function ImageCarouselFeature1() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % feature_images1.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel fade-carousel">
      {feature_images1.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Feature"
          className={`carousel-img ${i === index ? "active" : ""}`}
        />
      ))}
    </div>
  );
}

/// Slide Carousel

function ImageCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel slide-carousel">
      <div
        className="carousel-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {images.map((img, i) => (
          <img key={i} src={img} alt="Feature" />
        ))}
      </div>
    </div>
  );
}

const BookDemoButton = () => {
  const navigate = useNavigate();
  const [bgColor, setBgColor] = useState("#F3BD00");

  const buttonStyle = {
    backgroundColor: bgColor,
    color: bgColor === "#0C2B4B" ? "#ffffff" : "#0C2B4B",
    padding: "14px 32px",
    borderRadius: "150px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "16px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    transition: "all 0.3s ease",
    border: "none",
    margin: "10px"
  };

  return (
    <button
      style={buttonStyle}
      onClick={() => navigate("/bookademo?product=eSchool")}
      onMouseEnter={() => setBgColor("#0C2B4B")}
      onMouseLeave={() => setBgColor("#F3BD00")}
    >
      Book a Demo
    </button>
  );
};
const HabiTech = () => {
 

  return (
    <div
      style={{
        borderLeft: "150px solid  #0C2B4B",
        borderRight: "150px solid #0C2B4B",
        // maxWidth: "1200px",
        // margin: "auto"
      }}
    >
      <div className="product-page">
        {/* TOP BOOK A DEMO BUTTON */}
        {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
          <BookDemoButton />
        </div> */}
        {/* Top Description */}
        <div className="product-header" style={{ textAlign: "center", padding: "20px 0 10px 0" }}>

          <h1 style={{ fontSize: "40px", color: "#0C2B4B", fontWeight: "600" }}>
            eSchool – Everything Your School Needs — In One Digital Platform
          </h1>

          <p
            style={{
              fontSize: "20px",
              marginTop: "20px",
              color: "#444",
              maxWidth: "900px",
              marginLeft: "auto",
              marginRight: "auto",
              lineHeight: "1.8"
            }}
          >
            A comprehensive school management platform designed to simplify academic administration, automate fee management 
            and improve communication between schools, teachers, parents, and students.
            The system provides a powerful web portal for school administration and teachers, 
            along with a mobile app for parents and students, creating a connected and efficient digital learning environment.
          </p>

          <div style={{ marginTop: "25px" }}>
            <p style={{ fontSize: "17px", color: "#555" }}>
              ✔ Student Management
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Fee Management & Online Payments
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Attendance Tracking
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Exam & Result Management
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Parent Communication
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Payroll & Performance Tracking
              &nbsp;&nbsp; | 
              ✔ Finance & Budget Allocation
              &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp;
              ✔ Mobile App for Parents
            </p>
          </div>

          <p
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#666",
              maxWidth: "800px",
              marginLeft: "auto",
              marginRight: "auto"
            }}
          >
            Access your cloud based School ERP management system anytime, anywhere with a
            seamless combination of a powerful web portal and a convenient
            mobile application.
          </p>
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <BookDemoButton />
          </div>

          <hr
            style={{
              height: "4px",
              backgroundColor: "#0C2B4B",
              border: "none",
              marginTop: "30px"
            }}
          />

        </div>
        {/* End Top Description */}

        {/* Start Problem Section */}

        <div style={{ padding: "20px 40px 40px 40px" }}>

          <h2
            style={{
              color: "#C62828",
              fontWeight: "700",
              fontSize: "30px",
              textAlign: "center",
              marginBottom: "15px"
            }}
          >
            Challenges Educational Institutions Face in Daily Administration
          </h2>

          <p
            style={{
              textAlign: "justify",
              textAlignLast: "left",
              fontSize: "18px",
              lineHeight: "1.7",
              color: "#555",
              maxWidth: "850px",
              margin: "0 auto 30px auto"
            }}
          >
            Managing an educational institute involves handling large amounts of academic, financial, and administrative information. 
            Many schools still rely on manual registers, spreadsheets, and disconnected systems, which increases 
            workload and reduces efficiency.
          </p>

          <div className="row" style={{ margin: "0" }}>

            <div className="col-md-8 mx-auto" >
              <ul style={{ fontSize: "17px", lineHeight: "2", paddingLeft: "80px" }}>
                <li>Manual fee collection and payment tracking</li>
                <li>Attendance records maintained in registers</li>
                <li>Difficulty managing student records and academic data</li>
                <li>Time-consuming exam result preparation</li>
                <li>Communication gaps between school and parents</li>
                <li>Large amount of paperwork and administrative workload</li>
                <li>Institution running cost</li>
                <li>Employees Attendance and processing</li>
                <li>Limited access to real-time academic and financial reports</li>
              </ul>
            </div>

          </div>

          <p 
          style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#666",
              maxWidth: "800px",
              marginLeft: "auto",
              marginRight: "auto"
            }}>
            eSchool ERP provides a centralized digital platform that simplifies school administration and connects teachers,
           parents, and students through one integrated system.
          </p>

        </div>
        {/* End Problem Section */}

        <hr
          style={{
            width: "800px",
            height: "4px",
            backgroundColor: "#0C2B4B",
            border: "none",
            margin: "40px auto"
          }}
        />

        {/* Start How HabiTech Works Section */}

        <div style={{ padding: "40px 40px 20px 40px", textAlign: "center" }}>

          <h2 style={{
            color: "#0C2B4B",
            fontSize: "32px",
            fontWeight: "600",
            marginBottom: "30px"
          }}>
            How eSchool Helps in 3 Simple Steps
          </h2>

          <div className="row">

            <div className="col-md-4">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>1️⃣ Setup Your Institution</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Define school details, academic structure, classes, and student
                  records with an easy one-time setup. Existing student data can
                  also be imported from Excel.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>2️⃣ Manage Academic & Administrative Tasks</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Manage student records, attendance, fee collection, exams,
                  results, and school communication through a centralized
                  web portal for administrators and teachers.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div style={{ padding: "20px" }}>
                <h3 style={{ color: "#1A73E8" }}>3️⃣ Parents & Students Stay Connected</h3>
                <p style={{ fontSize: "17px", lineHeight: "1.7", color: "#555" }}>
                  Parents and students stay informed through the mobile app
                  where they can view attendance, receive notices, track
                  academic progress, and make secure online fee payments.
                </p>
              </div>
            </div>

          </div>

        </div>

        {/* End How HabiTech Works Section */}

        <hr
          style={{
            width: "800px",
            height: "4px",
            backgroundColor: "#0C2B4B",
            border: "none",
            margin: "40px auto"
          }}
        />

        {/* Start Why eSchool */}

        <div style={{ padding: "50px 40px", textAlign: "center" }}>

          <h2 style={{
            color: "#0C2B4B", //"#FF681F",
            fontSize: "34px",
            fontWeight: "600",
            marginBottom: "40px"
          }}>
            Why Choose eSchool ERP
          </h2>

            <div className="row text-center">

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    💰 Reduce Running Costs
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Automation and digitalization of administrative tasks reduces operational expenses.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    💳 Improve Fee Collection
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Online payments, reminders and mobile App features help increase fee collection efficiency.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    🕒 Easy Attendance
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Teachers can record attendance digitally without manual registers.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    💼 Payroll Processing
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Manage staff salary, deductions, and payroll reports automatically.
                  </p>
                </div>
              </div>

          </div> 

          <div className="row text-center">

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    📈 Performance Tracking
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Monitor staff performance and academic activities effectively.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    📊 Budget Allocation
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Plan and allocate budgets across departments with better control.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    📑 Financial Review
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    Access financial reports to track income, expenses, and growth.
                  </p>
                </div>
              </div>

              <div className="col-md-3 mb-4">
                <div
                  style={{
                    background: "#F5F5F5",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
                    height: "100%"
                  }}
                >
                  <h4 style={{ fontWeight: "600", marginBottom: "15px", color: "#FF681F" }}>
                    ⚙️ Cost-Effective ERP
                  </h4>
                  <p style={{ fontSize: "16px", color: "#0C2B4B", lineHeight: "1.6" }}>
                    A powerful yet affordable system designed for modern schools.
                  </p>
                </div>
              </div>

          </div> 

        </div>

        {/* End Why eSchool */}

        <hr
          style={{
            width: "800px",
            height: "4px",
            backgroundColor: "#0C2B4B",
            border: "none",
            margin: "40px auto"
          }}
        />

        <div style={{ padding: "10px 40px 20px 40px", textAlign: "center" }}>

          <h2 style={{
            color: "#0C2B4B",
            fontSize: "32px",
            fontWeight: "600",
            marginBottom: "30px"
          }}>
            eSchool Features at a Glance
          </h2>
        </div>

        <div className="feature-wrapper">

          {/* Section 2 : Brief Solution (reversed)  757575 */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#43A047", fontWeight: "600" }}>
                HabiTech provides a simpler, smarter way to manage your Society.
              </h2>
              <p style={{ textAlign: "justify" }}>
                Our cloud-based Solution replaces manual work with a centralized digital system for Admin Staff, Teachers and Parents.
                The platform works through two seamlessly connected components :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li> Web Portal for the Admin Team/Teachers.</li>
                <li>Mobile App for Parents/Students.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselSolution />
            </div>
          </div>

          {/* Feature Section 3 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Easy One Time Setup of Admin Data</h2>
              <p style={{ textAlign: "justify" }}>
                Define your Society Data with ease : </p><br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Society Master</li>
                <li>Setup Discount or Penalty or Interest.</li>
                <li>Create or Import Members/Owners Data.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselFeature1 />
              {/* <img src="/assets/img/HT_Scty_Prob2.png" className="responsive-img" /> */}
            </div>
          </div>

          {/* Section 4 : Web Portal Feature (reversed)  */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}> Maintenance Computation </h2>
              <p style={{ textAlign: "justify" }}>
                Maintenance Computation are based on your defined parameters with Penalties or discounts :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>System to compute late payment interest or penalties.</li>
                <li>Discount/Rebate on yearly maintenance.</li>
                <li>Maintenance structure can be changed in between the year.</li>
                <li>Offline maintenance can still be collected through chques/drafts.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselMaintCompt />
              {/* <img src="/assets/img/HT_Scty_Problem.png" className="responsive-img" /> */}
            </div>
          </div>

          {/* Feature Section 5 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Manage Tenants and Parkings</h2>
              <p style={{ textAlign: "justify" }}>
                Define sublet charges for rented properties. Allocation of Parking : </p><br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Define sublet charges.</li>
                <li>Allocate/Deallocate parking slots to Owners.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselTenantPark />
            </div>
          </div>

          {/* Section 6 : Web Portal Feature (reversed)  */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}> Communicating with Mobile Paltform </h2>
              <p style={{ textAlign: "justify" }}>
                Managing Committee to use Web Portal to communicate with Members. No need to type the Notices, just speak the notice and it will be written. :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>General Notices can be sent.</li>
                <li>AGM/SGM/MOM to be sent.</li>
                <li>Send Notice/Message to individual Member.</li>
                <li>Reply to Members Complaints/Request, raised online.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselCommMembers/>
            </div>
          </div>

          {/* Feature Section 7 : Web Portal Feature */}
          <div className="feature-row">
            <div className="feature-text">
              <h2 style={{ color: "#1A73E8" }}>Finance</h2>
              <p style={{ textAlign: "justify" }}>
                Easy to use Finance features, saves voucher entry efforts: </p><br />
              <ul style={{ paddingLeft: "20px" }}>
                <li>Auto Receipt Voucher posting in Finance.</li>
                <li>Budget Allocation.</li>
                <li>All Finance Reports.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselFinance />
            </div>
          </div>

          {/* Section 8 : Brief Solution (reversed)  757575 */}
          <div className="feature-row reverse">
            <div className="feature-text">
              <h2 style={{ color: "#32CD32" }}> Mobile App For Members </h2>
              <p style={{ textAlign: "justify" }}>
                Easy to use Mobile App for Members, for greener environment :</p> <br />
              <ul style={{ textAlign: "justify", paddingLeft: "20px" }}>
                <li>Securely Maintenance Payment through any online payment mode.</li>
                <li>Maintenance Receipts are available online in pfd format, no receipt printing.</li>
                <li>Members can Read or Hear a Notice in multi languages.</li>
                <li>Notice alerta on the App.</li>
                <li>Members can raise Complaints/Suggestion/Request.</li>
                <li>Members can Like/dislike other Members' Suggestion.</li>
              </ul>
            </div>
            <div className="feature-image">
              <ImageCarouselMobApp />
            </div>
          </div>
          {/* BOTTOM BOOK A DEMO BUTTON */}
          {/* BOTTOM BOOK A DEMO BUTTON */}
          <div style={{ textAlign: "center", margin: "40px 0" }}>
            <BookDemoButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HabiTech;
